interface TradersIconProps {
  status: 'active' | 'paused' | 'blocked' | 'unconnect' | 'deleted'
  className?: string
}

export const TradersIcon = (props: TradersIconProps) => {
  const { status = 'unconnect', className } = props
  const fillColor = {
    active: 'var(--status-green-fill)',
    paused: 'var(--status-grey-fill)',
    blocked: 'var(--status-red-fill)',
    unconnect: 'var(--status-yellow-fill)',
    deleted: 'var(--status-red-fill)',
  }[status]
  const pathColor = {
    active: 'var(--status-green-stroke)',
    paused: 'var(--status-grey-stroke)',
    blocked: 'var(--status-red-stroke)',
    unconnect: 'var(--status-yellow-stroke)',
    deleted: 'var(--status-red-stroke)',
  }[status]

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="20" fill={fillColor} />
      <path
        d="M10 26C10 24.9391 10.3424 23.9217 10.9519 23.1716C11.5614 22.4214 12.388 22 13.25 22H19.75C20.612 22 21.4386 22.4214 22.0481 23.1716C22.6576 23.9217 23 24.9391 23 26C23 26.5304 22.8288 27.0391 22.524 27.4142C22.2193 27.7893 21.806 28 21.375 28H11.625C11.194 28 10.7807 27.7893 10.476 27.4142C10.1712 27.0391 10 26.5304 10 26Z"
        stroke={pathColor}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 18C18.433 18 20 16.433 20 14.5C20 12.567 18.433 11 16.5 11C14.567 11 13 12.567 13 14.5C13 16.433 14.567 18 16.5 18Z"
        stroke={pathColor}
        strokeWidth="1.5"
      />
      <path
        d="M24.1797 22H27.0888C27.8603 22 28.6003 22.4214 29.1458 23.1716C29.6914 23.9217 29.9979 24.9391 29.9979 26C29.9979 26.5304 29.8446 27.0391 29.5718 27.4142C29.2991 27.7893 28.9291 28 28.5433 28H25.9979"
        stroke={pathColor}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 18C26.8807 18 28 16.8807 28 15.5C28 14.1193 26.8807 13 25.5 13C24.1193 13 23 14.1193 23 15.5C23 16.8807 24.1193 18 25.5 18Z"
        stroke={pathColor}
        strokeWidth="1.5"
      />
    </svg>
  )
}
